export default "__VITE_ASSET__4ce72b91__"